import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const WaitlistPage = () => {
    return (
        <>
            <div className="landing-header" style={{ position: 'relative' }}>
                <Link to="/pricing" className="pricing-brand">
                    <img src="images/autochef_logo.svg" alt="" className="company-logo" />
                    <span className="company-name" style={{ color: '#000000' }}>AutoChef</span>
                </Link>
            </div>

            <Container className="py-5">
                <Row className="justify-content-center text-center">
                    <Col md={8}>
                        <h1 className="mb-4">You're on the waitlist!</h1>
                        <p className="lead">
                            Thank you for your interest in AutoChef. We're thrilled to have you join us 
                            and can't wait for you to transform your meal planning experience.
                        </p>
                        <p className="text-muted">
                            We'll reach out as soon as a spot opens up. Stay tuned!
                        </p>
                    </Col>
                </Row>
            </Container>
        </>
    );
};

export default WaitlistPage;

